const setConfig = function(){
  //console.log(process.env.NODE_ENV)
  if(process.env.NODE_ENV == "development"){
    return  {
      oidc: {
        clientId: '0oa1cdgwrcmUP5YGI357',
        issuer: 'https://dev-198724.okta.com/oauth2/default', 
        redirectUri: 'https://dev.glxm.cleoma.fr/implicit/callback',
        scopes: ['openid', 'profile', 'email'],
        pkce: true,
      },
      baseURL : 'https://dev.api.glxm.cleoma.fr/'
    }
  }
  if(process.env.NODE_ENV == "production"){
    return  {
      oidc: {
        clientId: '0oa1cdgwrcmUP5YGI357',
        issuer: 'https://dev-198724.okta.com/oauth2/default', 
        redirectUri: 'https://manage.galaxiemedia.fr/implicit/callback',
        scopes: ['openid', 'profile', 'email'],
        pkce: true,
      },
      baseURL : 'https://api.manage.galaxiemedia.fr/'
    }
  }
}

module.exports = setConfig()